module.exports = __webpack_public_path__ + "assets/AngleIsoscelesDetailed.9abb126853dc8dc80c49e0d744d2ed16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AngleIsoscelesDetailed.png
// module id = 466
// module chunks = 0